import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-crystalreports',
  templateUrl: './crystalreports.component.html',
  styleUrls: ['./crystalreports.component.css']
})

export class CrystalreportsComponent implements OnInit {
  @Input()
  value: any;
  url: any;
  // url: string = "http://localhost:55308/index.aspx";
  urlSafe: SafeResourceUrl;

  constructor(public sanitizer: DomSanitizer, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.value = params.id;
      switch (this.value) {
        case "1":
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl("http://sems.guc.ac.bw:1080/Reports/frmSubjectsrpt.aspx");
          break;
        case "2":
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl("http://sems.guc.ac.bw:1080/Reports/frmBatchrpt.aspx");
          break;
        case "3":
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl("http://sems.guc.ac.bw:1080/Reports/frmResultSlip.aspx");
          break;
        case "4":
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl("http://sems.guc.ac.bw:1080/Reports/frmTranscript.aspx");
          break;
        case "5":
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl("http://sems.guc.ac.bw:1080/Reports/frmCertificate.aspx");
          break;
        case "6":
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl("http://sems.guc.ac.bw:1080/Reports/frmBestStudents.aspx");
          break;
        default:
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl("http://sems.guc.ac.bw:1080/Reports/frmSubjectsrpt.aspx");
          break;
      }
    });
  }
}